import React from 'react';
import Navbar from './Navbar';

/**
 * Layout Component
 * Provides consistent layout structure for all pages
 *
 * @param {Object} props Component props
 * @param {React.ReactNode} props.children Page content
 */
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Navigation */}
      <Navbar />

      {/* Main content */}
      <main className="flex-grow">
        {children}
      </main>

      {/* Footer */}
      <footer className="py-4 bg-white border-t border-gray-200">
        <div className="container mx-auto px-4">
          <p className="text-center text-sm text-gray-500">
            HelpScout Dashboard &copy; {new Date().getFullYear()}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
